export default __webpack_public_path__ + "static/media/Base_Name_Service.f8a1ede4.jpeg";